import { createFileRoute } from '@tanstack/react-router'
import { MessagesSquare } from 'lucide-react'
import { z } from 'zod'
import { SessionsScreen } from '@/screens/workspace/SCR-008-sessions'

export const Route = createFileRoute('/_app/w/$ws/sessions')({
  staticData: { screen: {"id":"SCR-008","title":"Sessions","group":"Workspace","perm":"memory.read","order":8,"description":"Agent sessions, their checkpoints and what they captured.", icon: MessagesSquare } },
  validateSearch: z.object({ q: z.string().max(200).optional(), s: z.string().max(200).optional() }),
  component: SessionsScreen,
})
